import {
    SETUP,
    FETCH_RESTAURANTS,
    FETCH_RESTAURANT,
    SAVE_RESTAURANT,
    UPDATE_RESTAURANT_ACTIVITY_PERIODS,
    UPDATE_RESTAURANT_DELIVERY_PERIODS,
    UPDATE_RESTAURANT_DELIVERY_AREAS,
    DELETE_RESTAURANT
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SETUP:
            return action.payload.businessApp.restaurants;
        case FETCH_RESTAURANTS:
            return action.payload;
        case FETCH_RESTAURANT:
            return state.map(rest => rest.id === (action.payload[0] || {}).id ? { ...rest, ...action.payload[0] } : rest);
        case SAVE_RESTAURANT:
            if (action.meta && action.meta.restId) {
                return state.map(rest => rest.id === action.meta.restId ? { ...rest, ...action.payload } : rest);
            }
            return state.concat(action.payload);
        case UPDATE_RESTAURANT_ACTIVITY_PERIODS:
            return state.map(rest => rest.id === action.meta.restId ? { ...rest, ...action.payload } : rest);
        case UPDATE_RESTAURANT_DELIVERY_PERIODS:
            return state.map(rest => rest.id === action.meta.restId ? { ...rest, ...action.payload } : rest);
        case UPDATE_RESTAURANT_DELIVERY_AREAS:
            return state.map(rest => rest.id === action.meta.restId ? { ...rest, ...action.payload } : rest);
        case DELETE_RESTAURANT:
            return state.filter(rest => rest.id !== action.meta.restId);
        default:
            return state;
    }
};
